import React, { useState, useEffect, useRef } from 'react';
import './style2.css';
import Paper from '@material-ui/core/Paper';
import Button2 from '@material-ui/core/Button';
import Logo from '../../assets/zelao.png';
import { Button } from 'primereact/button';
import axios from 'axios';
import { Formik } from 'formik';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import HeaderRelatorio from './HeaderRelatorio';
import { ProgressSpinner } from 'primereact/progressspinner';
import moment from 'moment/min/moment-with-locales';
import './Css/DataTableDemo.css';
import { Pdf_vendedores , Pdf_supervisores } from './pdf-relatorios';

import {
    IdBody,
    InscricaoBody,
    AssociadoBody,
    CidadeBody,
    ValorPagoBody,
    ValorComissaoBody,
    PercentualBody,
    PlanoBody,
    TipoBody,
    AceiteBody,
    FonteBody,
    SupervisorBody,
    bodyTotalComissaoCoordenador,
    bodyPagamento,
    bodyTotalComissaoSupervisor,
    bodyValorComissaoVendedor,
    bodyValorPagoVendedor
} from './bodyTemplate';
import { decriptObjectOnLocalStorage, decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import { retornoHashValor } from '../../modulos/cripotografia/hash';

export default function Relatorios({ history }) {
    const [value, setValue] = useState(false);
    const [loading, setLoading] = useState(false);
    const [coordenador, setCoordenador] = useState(false);
    const [vendedor, setVendedor] = useState(false);
    const [supervisor, setSupervisor] = useState(false);
    const [showSup, setShowSup] = useState(false);
    const [showCoordenador, setShowCoordenador] = useState(false);
    const [showVendedor, setShowVendedor] = useState(false);
    const [dataInicial, setDataInicial] = useState('');
    const [dataFinal, setDataFinal] = useState('');
    const [globalFilter, setGlobalFilter] = useState(null);
    const [expandedRows, setExpandedRows] = useState(null);
    const [expandedRows2, setExpandedRows2] = useState(null);
    const [expandedRows3, setExpandedRows3] = useState(null);
    const [comissaoPdf, setcomissaoPdf] = useState(null);
    const toast = useRef(null);
    const [tipagem, setTipagem] = useState('');
    const api = axios.create({
        baseURL: retornoHashValor(process.env.REACT_APP_7),
        headers: {
            Authorization:
                'Bearer ' +
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJOaWNrIjoiaXRhdSJ9.OgMNHaq0W3Z9Z6fM0ihjIFNjRp8ELfWrKnI1rGYJhVY'
        }
    });

    const vendedorComum = false;
    const vendedorPrime = false;
    let areaColaborador;
    const area = decriptoLocalStorage('area');

    switch (area) {
    case '1':
        areaColaborador = 'EXTERNO';
        break;
    case null:
        areaColaborador = 'EXTERNO';
        break;
    case '2':
        areaColaborador = 'TELEMARKETING';
        break;
    case '3':
        areaColaborador = 'PRIME';
        break;
    case '4':
        areaColaborador = 'PDV';
        break;
    case '5':
        areaColaborador = 'TERCEIRIZADO';
        break;
    default:
        areaColaborador = 'PRIME';
    }

    //codigo vendedor local storage
    const codigo = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;
    const permissao = decriptObjectOnLocalStorage('PERM');
    const nomeUsuario = decriptoLocalStorage('Nome')?.decriptoValue;

    useEffect(() => {
        if (permissao == 1) {
            setTipagem('vendedor');
        } else if (permissao == 2) {
            setTipagem('coordenador');
        } else if (permissao == 3) {
            setTipagem('supervisor');
        } else {
            setTipagem('gerente');
        }
    }, [value]);

    useEffect(() => {
        const handleSubmit = async () => {
            setLoading(true);

            const dateInicio = moment().format('01-MM-YYYY');
            const dateFim = moment().format('DD-MM-YYYY');
            const body = {
                codigo,
                data_inicio: moment().format('YYYY-MM-01'),
                data_fim: moment().format('YYYY-MM-DD'),
                tipo: areaColaborador
            };

            setDataInicial(dateInicio);
            setDataFinal(dateFim);

            const response = await api
                .post(`/relatorio/${tipagem}`, body)
                .then(resp => {
                    const vendedores =
                        resp.data[Object.keys(resp.data)[0]].vendas;

                    setValue(vendedores);
                    setShowSup(tipagem === 'supervisor');
                    setShowVendedor(tipagem === 'vendedor');
                    setShowCoordenador(tipagem === 'coordenador');
                    setLoading(false);
                })
                .catch(err => {
                    console.log(err);
                });
        };

        handleSubmit();
    }, [tipagem]);

    const initialValues = {
        codigo: '',
        data_inicio: '',
        data_fim: '',
        tipo: '',
        tipagem: ''
    };

    moment.locale('pt-br');

    const dataTitle = moment(new Date(), ['DD%MM%YYYY']).format('MMMM YYYY');
    const dataSubTitle = moment(new Date(), ['DD%MM%YYYY']).format(
        'DD/MM/YYYY'
    );
    const timeSubTitle = moment(new Date()).format(' HH:mm');

    const headerTemplate = data => (
        <>
            {showSup && (
                <span className="image-text">
                        Supervisor: {data.NomeSupervisor} - {data.Supervisor}
                </span>
            )}
            {showVendedor && (
                <span className="image-text">
                        Vendedor: {data.nomeVendedor} - {data.Vendedor}
                </span>
            )}
            {showCoordenador && (
                <span className="image-text">
                        Coordenador: {data.NomeCoordenador} - {data.Coordenador}
                </span>
            )}
        </>
    );

    const formatCurrency = value => value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });

    const footerTemplateVendedor = data => (
        <>
            <td
                colSpan="6"
                style={{
                    textAlign: 'right',
                    backgroundColor: '#f8f9fa'
                }}
            >
                <Button
                    label="PDF"
                    icon="pi pi-file-pdf"
                    variant="contained"
                    color="secondary"
                    onClick={buscarPdf}
                    className="p-button-info p-ml-auto"
                    style={{ marginRight: '2%' }}
                />
                    Total da Comissão:
            </td>
            <td
                style={{
                    //textAlign: 'right',
                    backgroundColor: '#f8f9fa'
                }}
            >
                {somaComissaoSup(data.nomeVendedor)}
            </td>
        </>
    );

    const somaComissaoSup = nomeVendedor => {
        let totalComissao = 0;

        if (value) {
            for (const valorC of value) {
                if (valorC.nomeVendedor === nomeVendedor) {
                    totalComissao += valorC.ValorComissao;
                }
            }

            setcomissaoPdf(formatCurrency(totalComissao));

            return formatCurrency(totalComissao);
        }
    };

    const footerVendedor = data => (
        <>
            <td colSpan="4" style={{ textAlign: 'right' }}>
                    Comissão Vendedor: {data}
            </td>
        </>
    );

    const expandirSupervisores = () => {
        const _expandedRows = {};
        const _expandirVendas = {};

        supervisor.forEach(
            p => (_expandedRows[`${p.NomeSupervisor}`] = true)
        );
        supervisor.forEach(v =>
            v.Vendas.forEach(
                vendas => (_expandirVendas[`${vendas.nomeVendedor}`] = true)
            )
        );
        setExpandedRows3(_expandirVendas);
        setExpandedRows(_expandedRows);
    };

    const fecharSupervisores = () => {
        setExpandedRows(null);
        setExpandedRows3(null);
    };

    const expandirCoordenadores = () => {
        const _expandirCoordenador = {};
        const _expandirSupervisor = {};
        const _expandirVendedor = {};

        coordenador.forEach(
            p => (_expandirCoordenador[`${p.NomeCoordenador}`] = true)
        );
        coordenador.forEach(p =>
            p.Vendas.forEach(
                vendas =>
                    (_expandirSupervisor[`${vendas.NomeSupervisor}`] = true)
            )
        );
        coordenador.forEach(p =>
            p.Vendas.forEach(
                vendas => (_expandirVendedor[`${vendas.nomeVendedor}`] = true)
            )
        );

        setExpandedRows(_expandirCoordenador);
        setExpandedRows2(_expandirSupervisor);
        setExpandedRows3(_expandirVendedor);
    };

    const fecharCoordenadores = () => {
        setExpandedRows(null);
        setExpandedRows2(null);
        setExpandedRows3(null);
    };

    const headerCoordenador = (
        <div className="table-header-container">
            <Button2 onClick={expandirCoordenadores}>Expandir Todos</Button2>
            <Button2
                style={{ marginLeft: '160px' }}
                onClick={fecharCoordenadores}
            >
                Esconder Todos
            </Button2>
        </div>
    );

    const headerSupervisor = (
        <div className="table-header-container">
            <Button2
                className="p-button-secondary"
                onClick={expandirSupervisores}
            >
                Expandir Todos
            </Button2>
            <Button
                style={{ marginLeft: '19%' }}
                label="PDF"
                icon="pi pi-file-pdf"
                className="p-button-rounded p-ml-auto"
                onClick={buscarPdfSupervisor}
            />
            <Button2
                className="p-button-secondary"
                style={{ marginLeft: '160px' }}
                onClick={fecharSupervisores}
            >
                Esconder Todos
            </Button2>
        </div>
    );

    if (showVendedor) {
        if (!vendedor) {
            const arrayVendedor = [];

            for (let i = 0; i < value.length; i++) {
                let newArray = false;

                for (let j = 0; j < i; j++) {
                    if (
                        arrayVendedor[j] &&
                        value[i].nomeVendedor === arrayVendedor[j].nomeVendedor
                    ) {
                        arrayVendedor[j].Vendas.push({
                            Id: value[i].Id,
                            aceite: value[i].aceite,
                            SubGrupo: value[i].SubGrupo,
                            Inscricao: value[i].Inscricao,
                            TipoVenda: value[i].TipoVenda,
                            Pagamento: value[i].Pagamento,
                            ValorPago: value[i].ValorPago,
                            NomeCidade: value[i].NomeCidade,
                            nomeVendedor: value[i].nomeVendedor,
                            NomeAssociado: value[i].NomeAssociado,
                            ValorCremacao: value[i].ValorCremacao,
                            NomeSupervisor: value[i].NomeSupervisor,
                            NomeCoordenador: value[i].NomeCoordenador,
                            FonteInformacao: value[i].FonteInformacao,
                            TotalComissaoVendedor: value[i].ValorComissao,
                            PercentualComissao: value[i].PercentualComissao
                        });
                        newArray = true;

                        arrayVendedor[j].TotalComissaoVendedor +=
                            value[i].ValorComissao;

                        break;
                    }
                }

                if (!newArray) {
                    arrayVendedor.push({
                        Id: value[i].Id,
                        aceite: value[i].aceite,
                        SubGrupo: value[i].SubGrupo,
                        Inscricao: value[i].Inscricao,
                        TipoVenda: value[i].TipoVenda,
                        Pagamento: value[i].Pagamento,
                        ValorPago: value[i].ValorPago,
                        NomeCidade: value[i].NomeCidade,
                        nomeVendedor: value[i].nomeVendedor,
                        NomeAssociado: value[i].NomeAssociado,
                        ValorCremacao: value[i].ValorCremacao,
                        NomeSupervisor: value[i].NomeSupervisor,
                        NomeCoordenador: value[i].NomeCoordenador,
                        FonteInformacao: value[i].FonteInformacao,
                        TotalComissaoVendedor: value[i].ValorComissao,
                        PercentualComissao: value[i].PercentualComissao,
                        Vendas: [
                            {
                                Id: value[i].Id,
                                aceite: value[i].aceite,
                                SubGrupo: value[i].SubGrupo,
                                Inscricao: value[i].Inscricao,
                                TipoVenda: value[i].TipoVenda,
                                Pagamento: value[i].Pagamento,
                                ValorPago: value[i].ValorPago,
                                NomeCidade: value[i].NomeCidade,
                                nomeVendedor: value[i].nomeVendedor,
                                NomeAssociado: value[i].NomeAssociado,
                                ValorCremacao: value[i].ValorCremacao,
                                NomeSupervisor: value[i].NomeSupervisor,
                                NomeCoordenador: value[i].NomeCoordenador,
                                FonteInformacao: value[i].FonteInformacao,
                                TotalComissaoVendedor: value[i].ValorComissao,
                                PercentualComissao: value[i].PercentualComissao
                            }
                        ]
                    });
                }
            }

            setVendedor(arrayVendedor);
        }
    }

    if (showSup) {
        if (!supervisor) {
            const arraySupervisor = [];

            for (let i = 0; i < value.length; i++) {
                let arrayIgual = false;

                for (let j = 0; j < i; j++) {
                    if (
                        arraySupervisor[j] &&
                        value[i].NomeSupervisor ==
                            arraySupervisor[j].NomeSupervisor
                    ) {
                        arraySupervisor[j].Vendas.push({
                            NomeSupervisor: value[i].NomeSupervisor,
                            nomeVendedor: value[i].nomeVendedor,
                            Id: value[i].Id,
                            NomeAssociado: value[i].NomeAssociado,
                            ValorPago: value[i].ValorPago,
                            PercentualComissao: value[i].PercentualComissao,
                            ValorComissao: value[i].ValorComissao,
                            ValorComissaoSupervisor:
                                value[i].ValorComissaoSupervisor,
                            Inscricao: value[i].Inscricao,
                            Pagamento: value[i].Pagamento
                        });
                        arrayIgual = true;

                        arraySupervisor[j].TotalComissaoSupervisor +=
                            value[i].ValorComissaoSupervisor;

                        break;
                    }
                }

                if (!arrayIgual) {
                    arraySupervisor.push({
                        NomeSupervisor: value[i].NomeSupervisor,
                        nomeVendedor: value[i].nomeVendedor,
                        TotalComissaoSupervisor:
                            value[i].ValorComissaoSupervisor,
                        Vendas: [
                            {
                                NomeSupervisor: value[i].NomeSupervisor,
                                nomeVendedor: value[i].nomeVendedor,
                                Id: value[i].Id,
                                NomeAssociado: value[i].NomeAssociado,
                                ValorPago: value[i].ValorPago,
                                PercentualComissao: value[i].PercentualComissao,
                                ValorComissao: value[i].ValorComissao,
                                ValorComissaoSupervisor:
                                    value[i].ValorComissaoSupervisor,
                                Inscricao: value[i].Inscricao,
                                Pagamento: value[i].Pagamento
                            }
                        ]
                    });
                }
            }

            setSupervisor(arraySupervisor);
        }
    }

    if (showCoordenador) {
        if (!coordenador) {
            const arrayCoordenador = [];

            for (let i = 0; i < value.length; i++) {
                let newArray = false;

                for (let j = 0; j < i; j++) {
                    if (
                        arrayCoordenador[j] &&
                        value[i].NomeCoordenador ==
                            arrayCoordenador[j].NomeCoordenador
                    ) {
                        arrayCoordenador[j].Vendas.push({
                            NomeSupervisor: value[i].NomeSupervisor,
                            NomeCoordenador: value[i].NomeCoordenador,
                            nomeVendedor: value[i].nomeVendedor,
                            Id: value[i].Id,
                            NomeAssociado: value[i].NomeAssociado,
                            ValorPago: value[i].ValorPago,
                            PercentualComissao: value[i].PercentualComissao,
                            ValorComissao: value[i].ValorComissao,
                            ValorComissaoCoordenador:
                                value[i].ValorComissaoCoordenador,
                            ValorComissaoSupervisor:
                                value[i].ValorComissaoSupervisor,
                            Inscricao: value[i].Inscricao,
                            Pagamento: value[i].Pagamento
                        });
                        newArray = true;

                        arrayCoordenador[j].TotalComissaoCoordenador +=
                            value[i].ValorComissaoCoordenador;

                        break;
                    }
                }

                if (!newArray) {
                    arrayCoordenador.push({
                        NomeCoordenador: value[i].NomeCoordenador,
                        NomeSupevisor: value[i].NomeSupevisor,
                        nomeVendedor: value[i].nomeVendedor,
                        TotalComissaoCoordenador:
                            value[i].ValorComissaoCoordenador,
                        Vendas: [
                            {
                                NomeSupervisor: value[i].NomeSupervisor,
                                NomeCoordenador: value[i].NomeCoordenador,
                                nomeVendedor: value[i].nomeVendedor,
                                Id: value[i].Id,
                                NomeAssociado: value[i].NomeAssociado,
                                ValorPago: value[i].ValorPago,
                                PercentualComissao: value[i].PercentualComissao,
                                ValorComissao: value[i].ValorComissao,
                                ValorComissaoSupervisor:
                                    value[i].ValorComissaoSupervisor,
                                ValorComissaoCoordenador:
                                    value[i].ValorComissaoCoordenador,
                                Inscricao: value[i].Inscricao,
                                Pagamento: value[i].Pagamento
                            }
                        ]
                    });
                }
            }

            setCoordenador(arrayCoordenador);
        }
    }

    const vendedoresTemplate = data => {
        const novoArray = [];

        for (let i = 0; i < data.Vendas.length; i++) {
            let arrayIgual = false;

            for (let j = 0; j < i; j++) {
                if (
                    novoArray[j] &&
                    data.Vendas[i].nomeVendedor == novoArray[j].nomeVendedor
                ) {
                    novoArray[j].Vendas.push({
                        nomeVendedor: data.Vendas[i].nomeVendedor,
                        Inscricao: data.Vendas[i].Inscricao,
                        Pagamento: data.Vendas[i].Pagamento,
                        Id: data.Vendas[i].Id,
                        NomeAssociado: data.Vendas[i].NomeAssociado,
                        ValorPago: data.Vendas[i].ValorPago,
                        PercentualComissao: data.Vendas[i].PercentualComissao,
                        ValorComissao: data.Vendas[i].ValorComissao,
                        ValorComissaoSupervisor:
                            data.Vendas[i].ValorComissaoSupervisor
                    });
                    arrayIgual = true;

                    novoArray[j].TotalComissao += data.Vendas[i].ValorComissao;
                    novoArray[j].TotalComisssaoSupervisor +=
                        data.Vendas[i].ValorComissaoSupervisor;
                    break;
                }
            }

            if (!arrayIgual) {
                novoArray.push({
                    nomeVendedor: data.Vendas[i].nomeVendedor,
                    TotalComissao: data.Vendas[i].ValorComissao,
                    TotalComissaoSupervisor:
                        data.Vendas[i].ValorComissaoSupervisor,
                    Vendas: [
                        {
                            nomeVendedor: data.Vendas[i].nomeVendedor,
                            Inscricao: data.Vendas[i].Inscricao,
                            Pagamento: data.Vendas[i].Pagamento,
                            Id: data.Vendas[i].Id,
                            NomeAssociado: data.Vendas[i].NomeAssociado,
                            ValorPago: data.Vendas[i].ValorPago,
                            PercentualComissao:
                                data.Vendas[i].PercentualComissao,
                            ValorComissao: data.Vendas[i].ValorComissao,
                            ValorComissaoSupervisor:
                                data.Vendas[i].ValorComissaoSupervisor
                        }
                    ]
                });
            }
        }

        return (
            <div className="orders-subtable">
                <DataTable
                    value={novoArray}
                    onRowToggle={e => setExpandedRows2(e.data)}
                    expandedRows={expandedRows2}
                    rowExpansionTemplate={vendasTemplate}
                    dataKey="nomeVendedor"
                >
                    <Column expander style={{ width: '3em' }} />
                    <Column field="nomeVendedor" header="Vendedor" />
                </DataTable>
            </div>
        );
    };

    const supervisorTemplate = data => {
        const novoArray = [];

        for (let i = 0; i < data.Vendas.length; i++) {
            let arrayIgual = false;

            for (let j = 0; j < i; j++) {
                if (
                    novoArray[j] &&
                    data.Vendas[i].NomeSupervisor == novoArray[j].NomeSupervisor
                ) {
                    novoArray[j].Vendas.push({
                        NomeCoordenador: data.Vendas[i].NomeCoordenador,
                        NomeSupervisor: data.Vendas[i].NomeSupervisor,
                        nomeVendedor: data.Vendas[i].nomeVendedor,
                        Inscricao: data.Vendas[i].Inscricao,
                        Descricao: data.Vendas[i].Descricao,
                        Pagamento: data.Vendas[i].Pagamento,
                        Id: data.Vendas[i].Id,
                        NomeAssociado: data.Vendas[i].NomeAssociado,
                        ValorPago: data.Vendas[i].ValorPago,
                        PercentualComissao: data.Vendas[i].PercentualComissao,
                        ValorComissaoSupervisor:
                            data.Vendas[i].ValorComissaoSupervisor,
                        ValorComissao: data.Vendas[i].ValorComissao
                    });
                    arrayIgual = true;
                    novoArray[j].TotalComissaoSupervisor +=
                        data.Vendas[i].ValorComissaoSupervisor;
                    break;
                }
            }

            if (!arrayIgual) {
                novoArray.push({
                    NomeCoordenador: data.Vendas[i].NomeCoordenador,
                    NomeSupervisor: data.Vendas[i].NomeSupervisor,
                    TotalComissaoSupervisor:
                        data.Vendas[i].ValorComissaoSupervisor,
                    Descricao: data.Vendas[i].Descricao,
                    Vendas: [
                        {
                            NomeCoordenador: data.Vendas[i].NomeCoordenador,
                            NomeSupervisor: data.Vendas[i].NomeSupervisor,
                            nomeVendedor: data.Vendas[i].nomeVendedor,
                            Inscricao: data.Vendas[i].Inscricao,
                            Descricao: data.Vendas[i].Descricao,
                            Pagamento: data.Vendas[i].Pagamento,
                            Id: data.Vendas[i].Id,
                            NomeAssociado: data.Vendas[i].NomeAssociado,
                            ValorPago: data.Vendas[i].ValorPago,
                            PercentualComissao:
                                data.Vendas[i].PercentualComissao,
                            ValorComissaoSupervisor:
                                data.Vendas[i].ValorComissaoSupervisor,
                            ValorComissao: data.Vendas[i].ValorComissao
                        }
                    ]
                });
            }
        }

        return (
            <div className="orders-subtable">
                <DataTable
                    value={novoArray}
                    onRowToggle={e => setExpandedRows2(e.data)}
                    expandedRows={expandedRows2}
                    rowExpansionTemplate={vendedoresTemplate}
                    dataKey="NomeSupervisor"
                    footer=""
                >
                    <Column expander style={{ width: '3em' }} />
                    <Column
                        field="NomeSupervisor"
                        header="Supervisores"
                        body={SupervisorBody}
                    />
                    <Column
                        field="TotalComissaoSupervisor"
                        header="Comissão Supervisor"
                        body={bodyTotalComissaoSupervisor}
                    />
                </DataTable>
            </div>
        );
    };

    const totalVendas = () => {
        let totalVendas = 0;

        if (value) {
            for (const valueVendas of value) {
                if (valueVendas.nomeVendedor) {
                    totalVendas++;
                }
            }

            return totalVendas;
        }
    };

    const vendasTemplate = data => (
        <DataTable
            value={data.Vendas}
            className="p-datatable-responsive-demo"
            footer={footerVendedor(data.TotalComissao)}
        >
            <Column
                field="NomeAssociado"
                header="Nome Associado"
                body={AssociadoBody}
            />
            <Column field="Id" header="Id" body={IdBody} />
            <Column
                field="Inscricao"
                header="Inscrição"
                body={InscricaoBody}
            />
            <Column
                field="Pagamento"
                header="Pagamento"
                body={bodyPagamento}
            />
            <Column
                field="ValorPago"
                header="Valor Pago"
                body={bodyValorPagoVendedor}
            />
            <Column
                field="PercentualComissao"
                header="% Comissao"
                body={PercentualBody}
            />
            <Column
                field="ValorComissao"
                header="Valor Comissão"
                body={bodyValorComissaoVendedor}
            />
        </DataTable>
    );

    // funões que leva os dados para pdf

    async function buscarPdf() {
        Pdf_vendedores(value, comissaoPdf, areaColaborador, nomeUsuario);
    }

    function buscarPdfSupervisor() {
        Pdf_supervisores(supervisor, areaColaborador, nomeUsuario);
    }

    return (
        <>
            <div className="container-relatorios">
                <Formik
                    onSubmit={''}
                    validateOnMount
                    initialValues={initialValues}
                >
                    {({ values }) => (
                        <>
                            <Paper
                                className="paper-relatorios"
                                style={{ height: '100px' }}
                            >
                                <aside className="aside-container">
                                    <span className="title-relatorios">
                                        <strong>Relatórios {tipagem}</strong> -{' '}
                                        <span className="data-title">
                                            {dataTitle}
                                        </span>
                                    </span>
                                    <span className="subTitle-relatorios">
                                        Criado em: {dataSubTitle} às{' '}
                                        {timeSubTitle}
                                    </span>
                                </aside>
                            </Paper>
                            {loading && (
                                <div style={{ display: 'flex' }}>
                                    <ProgressSpinner
                                        style={{
                                            width: '100px',
                                            height: '100px'
                                        }}
                                        strokeWidth="1"
                                        fill="#EEEEEE"
                                        animationDuration=".5s"
                                    />
                                </div>
                            )}

                            <Paper className="paper-conteudo_relatorios  datatable-responsive-demo">
                                <div className="conteudo-relatorios">
                                    {showSup && (
                                        <>
                                            <HeaderRelatorio
                                                img={Logo}
                                                title={tipagem.toUpperCase()}
                                                vendas={totalVendas()}
                                                dataInicio={dataInicial}
                                                dataFim={dataFinal}
                                            />
                                            {/* Tabela */}
                                            {showSup && (
                                                <DataTable
                                                    value={supervisor}
                                                    onRowToggle={e =>
                                                        setExpandedRows(e.data)
                                                    }
                                                    expandedRows={expandedRows}
                                                    rowExpansionTemplate={
                                                        vendedoresTemplate
                                                    }
                                                    dataKey="NomeSupervisor"
                                                    header={headerSupervisor}
                                                >
                                                    <Column
                                                        expander
                                                        style={{
                                                            width: '3em'
                                                        }}
                                                    />
                                                    <Column
                                                        field="NomeSupervisor"
                                                        header="Supervisores"
                                                        style={{
                                                            backgroundColor:
                                                                '#f8f9fa'
                                                        }}
                                                    />
                                                    <Column
                                                        field="TotalComissaoSupervisor"
                                                        header="Comissão Supervisor"
                                                        body={
                                                            bodyTotalComissaoSupervisor
                                                        }
                                                        style={{
                                                            backgroundColor:
                                                                '#f8f9fa'
                                                        }}
                                                    />
                                                </DataTable>
                                            )}
                                        </>
                                    )}
                                    {showVendedor && (
                                        <>
                                            <HeaderRelatorio
                                                img={Logo}
                                                title={tipagem.toUpperCase()}
                                                vendas={totalVendas()}
                                                dataInicio={dataInicial}
                                                dataFim={dataFinal}
                                            />

                                            {vendedorComum && (
                                                <DataTable
                                                    value={value}
                                                    rowGroupMode="subheader"
                                                    groupField="nomeVendedor"
                                                    sortMode="Id"
                                                    sortField="nomeVendedor"
                                                    rowGroupHeaderTemplate={
                                                        headerTemplate
                                                    }
                                                    rowGroupFooterTemplate={
                                                        footerTemplateVendedor
                                                    }
                                                    rows={12}
                                                    rowsPerPageOptions={[
                                                        12,
                                                        20,
                                                        50
                                                    ]}
                                                    // paginatorLeft={
                                                    //     paginatorLeft
                                                    // }
                                                    // paginatorRight={
                                                    //     paginatorRight
                                                    // }
                                                    paginator
                                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                                    currentPageReportTemplate="Página {first} para {last} de {totalRecords}"
                                                    key="Id"
                                                    className="p-datatable-responsive-demo"
                                                    globalFilter={globalFilter}
                                                    // header={
                                                    //     headerExport_Vendedor
                                                    // }
                                                >
                                                    <Column
                                                        field="NomeAssociado"
                                                        header="Nome Associado"
                                                        body={AssociadoBody}
                                                        bodyStyle={{
                                                            fontSize: '10px'
                                                        }}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="Id"
                                                        header="Id"
                                                        headerStyle={{
                                                            width: '69px'
                                                        }}
                                                        body={IdBody}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="Inscricao"
                                                        header="Inscrição"
                                                        body={InscricaoBody}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="NomeCidade"
                                                        header="Cidade"
                                                        bodyStyle={{
                                                            fontSize: '11px'
                                                        }}
                                                        body={CidadeBody}
                                                        className="column-style"
                                                    ></Column>

                                                    <Column
                                                        field="TipoVenda"
                                                        bodyStyle={{
                                                            fontSize: '12px'
                                                        }}
                                                        header="Tipo Venda"
                                                        body={TipoBody}
                                                        className="column-style"
                                                    ></Column>

                                                    <Column
                                                        field="aceite"
                                                        header="Aceite"
                                                        body={AceiteBody}
                                                        headerStyle={{
                                                            width: '56px'
                                                        }}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="FonteInformacao"
                                                        header="Fonte Portal"
                                                        body={FonteBody}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="SubGrupo"
                                                        header="Plano"
                                                        headerStyle={{
                                                            width: '53px'
                                                        }}
                                                        body={PlanoBody}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="Pagamento"
                                                        header="Pagamento"
                                                        body={bodyPagamento}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="ValorCremacao"
                                                        header="Valor Cremação"
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="ValorPago"
                                                        header="Valor Pago"
                                                        body={ValorPagoBody}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="PercentualComissao"
                                                        header="% Comissão"
                                                        body={PercentualBody}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="ValorComissao"
                                                        header="Comissão Plano"
                                                        body={ValorComissaoBody}
                                                        className="column-style"
                                                    ></Column>
                                                </DataTable>
                                            )}

                                            {vendedorPrime && (
                                                <DataTable
                                                    value={value}
                                                    rowGroupMode="subheader"
                                                    groupField="nomeVendedor"
                                                    sortMode="Id"
                                                    sortField="nomeVendedor"
                                                    rowGroupHeaderTemplate={
                                                        headerTemplate
                                                    }
                                                    rowGroupFooterTemplate={
                                                        footerTemplateVendedor
                                                    }
                                                    rows={12}
                                                    rowsPerPageOptions={[
                                                        12,
                                                        20,
                                                        50
                                                    ]}
                                                    // paginatorLeft={
                                                    //     paginatorLeft
                                                    // }
                                                    // paginatorRight={
                                                    //     paginatorRight
                                                    // }
                                                    paginator
                                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                                    currentPageReportTemplate="Página {first} para {last} de {totalRecords}"
                                                    key="Id"
                                                    className="p-datatable-responsive-demo"
                                                    globalFilter={globalFilter}
                                                    // header={
                                                    //     headerExport_Vendedor
                                                    // }
                                                >
                                                    <Column
                                                        field="NomeAssociado"
                                                        header="Nome Associado"
                                                        body={AssociadoBody}
                                                        bodyStyle={{
                                                            fontSize: '10px'
                                                        }}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="Id"
                                                        header="Id"
                                                        headerStyle={{
                                                            width: '69px'
                                                        }}
                                                        body={IdBody}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="Inscricao"
                                                        header="Inscrição"
                                                        body={InscricaoBody}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="SubGrupo"
                                                        header="Plano"
                                                        headerStyle={{
                                                            width: '53px'
                                                        }}
                                                        body={PlanoBody}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="Pagamento"
                                                        header="Pagamento"
                                                        body={bodyPagamento}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="ValorPago"
                                                        header="Valor Pago"
                                                        body={ValorPagoBody}
                                                        className="column-style"
                                                    ></Column>
                                                    <Column
                                                        field="ValorComissao"
                                                        header="Comissão Plano"
                                                        body={ValorComissaoBody}
                                                        className="column-style"
                                                    ></Column>
                                                </DataTable>
                                            )}
                                        </>
                                    )}
                                    {showCoordenador && (
                                        <>
                                            <HeaderRelatorio
                                                img={Logo}
                                                title={tipagem.toUpperCase()}
                                                vendas={totalVendas()}
                                                dataInicio={dataInicial}
                                                dataFim={dataFinal}
                                            />

                                            {/* Tabela */}
                                            {showCoordenador && (
                                                <DataTable
                                                    value={coordenador}
                                                    //className="p-datatable-responsive-demo"
                                                    onRowToggle={e =>
                                                        setExpandedRows(e.data)
                                                    }
                                                    expandedRows={expandedRows}
                                                    rowExpansionTemplate={
                                                        supervisorTemplate
                                                    }
                                                    dataKey="NomeCoordenador"
                                                    header={headerCoordenador}
                                                >
                                                    <Column
                                                        expander
                                                        style={{
                                                            width: '3em'
                                                        }}
                                                    />
                                                    <Column
                                                        field="NomeCoordenador"
                                                        header="Coordenadores"
                                                        style={{
                                                            backgroundColor:
                                                                '#f8f9fa'
                                                        }}
                                                    />
                                                    <Column
                                                        field="TotalComissaoCoordenador"
                                                        header="Comissão Coordenador"
                                                        body={
                                                            bodyTotalComissaoCoordenador
                                                        }
                                                        style={{
                                                            backgroundColor:
                                                                '#f8f9fa'
                                                        }}
                                                    />
                                                </DataTable>
                                            )}
                                        </>
                                    )}
                                </div>
                            </Paper>
                        </>
                    )}
                </Formik>
            </div>
        </>
    );
}
